/**
 * ラリーのスポットを地図に描くマーカー群
 *
 * GoogleMapCanvas の子として使う。地図そのものは呼び出し側が用意するので、
 * ルートの線など別のレイヤーと同じ地図に重ねられる。
 */

import type { RallyMapItem } from '@/api/types/stamp-rally'

import { GoogleCircleMarker } from './google-circle-marker'
import { type RallyPlaceGroup, RallyPlacePopup } from './rally-place-popup'
import type { VisiblePlace } from './use-rally-places'

const UNSTAMPED_OPACITY = 0.5
const STAMPED_OPACITY = 0.9
const ACTIVE_RING_COLOR = '#111827'

type Props = {
  visible: VisiblePlace[]
  colorOf: (item: RallyMapItem) => string
  selectedPlaceIds: number[]
  /** ポップアップを開いている場所 */
  activePlaceId: number | null
  onActivate: (placeId: number | null) => void
  onToggle: (place: RallyPlaceGroup) => void
  onToggleStamp: (item: RallyMapItem, stamped: boolean) => void
  /** ポップアップのラリー行を押したときの動き。省略するとそのラリーの詳細へ飛ぶ */
  onSelectItem?: (item: RallyMapItem) => void
}

export const RallyMapMarkers = ({
  visible,
  colorOf,
  selectedPlaceIds,
  activePlaceId,
  onActivate,
  onToggle,
  onToggleStamp,
  onSelectItem,
}: Props) => {
  const activePlace = visible.find(({ place }) => place.placeId === activePlaceId)?.place ?? null

  return (
    <>
      {visible.map(({ place, shown }) => {
        const selected = selectedPlaceIds.includes(place.placeId)
        const active = activePlaceId === place.placeId
        const color = colorOf(shown[0])
        return (
          <GoogleCircleMarker
            key={place.placeId}
            position={place.position}
            radius={selected || active ? 11 : 7}
            color={selected ? '#FFFFFF' : active ? ACTIVE_RING_COLOR : color}
            fillColor={color}
            fillOpacity={shown.every((item) => item.stamped_at) ? STAMPED_OPACITY : UNSTAMPED_OPACITY}
            weight={selected || active ? 3 : 2}
            zIndex={selected || active ? 10 : 1}
            onClick={() => onActivate(active ? null : place.placeId)}
          />
        )
      })}

      {activePlace && (
        <RallyPlacePopup
          place={activePlace}
          selected={selectedPlaceIds.includes(activePlace.placeId)}
          onToggleSelect={() => onToggle(activePlace)}
          onToggleStamp={onToggleStamp}
          onSelectItem={onSelectItem}
          onClose={() => onActivate(null)}
        />
      )}
    </>
  )
}
